var $390613981d970276$exports = {};
$390613981d970276$exports = {
    "Clear search": `T\xfchjenda otsing`
};


export {$390613981d970276$exports as default};
//# sourceMappingURL=et-EE.module.js.map
